export var ROUTINE_PROMISE_ACTION = '@@redux-saga-routines/PROMISE';